var _circle, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTaskSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 28,
    r: 28,
    fill: "#FFEBC4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_26065_34524",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 8,
    width: 72,
    height: 72
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 8,
    width: 72,
    height: 72,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_26065_34524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.002 74.4485C31.829 74.4485 27.8905 73.6515 24.1865 72.0575C20.483 70.4635 17.2483 68.2835 14.4823 65.5175C11.7163 62.7515 9.53627 59.5175 7.94227 55.8155C6.34827 52.1135 5.55127 48.1758 5.55127 44.0023C5.55127 39.7793 6.34827 35.8158 7.94227 32.1118C9.53627 28.4083 11.7153 25.1858 14.4793 22.4443C17.2433 19.7023 20.4768 17.5318 24.1798 15.9328C27.8828 14.3333 31.8215 13.5335 35.996 13.5335C40.22 13.5335 44.1848 14.3328 47.8903 15.9313C51.5953 17.5298 54.818 19.699 57.5585 22.439C60.2995 25.179 62.4693 28.401 64.0678 32.105C65.6668 35.809 66.4663 39.774 66.4663 44C66.4663 48.175 65.6665 52.1143 64.067 55.8178C62.468 59.5213 60.2975 62.7553 57.5555 65.5198C54.814 68.2843 51.5923 70.4635 47.8903 72.0575C44.1883 73.6515 40.2255 74.4485 36.002 74.4485ZM35.9998 69.3388C43.0518 69.3388 49.038 66.87 53.9585 61.9325C58.8785 56.9945 61.3385 51.017 61.3385 44C61.3385 36.948 58.8785 30.9618 53.9585 26.0413C49.038 21.1213 43.0488 18.6613 35.9908 18.6613C28.9828 18.6613 23.009 21.1213 18.0695 26.0413C13.1305 30.9618 10.661 36.951 10.661 44.009C10.661 51.017 13.1298 56.9908 18.0673 61.9303C23.0053 66.8693 28.9828 69.3388 35.9998 69.3388Z",
    fill: "#395966"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5307 42.5725L31.5395 52.2778L47.231 30.5253C47.738 29.8357 48.3655 29.4736 49.1135 29.439C49.8615 29.4044 50.5095 29.7319 51.0575 30.4215C51.6175 31.1928 51.8975 32.0748 51.8975 33.0677C51.8975 34.0606 51.6175 34.9364 51.0575 35.6952L33.3477 60.2435C32.8262 60.949 32.222 61.3018 31.535 61.3018C30.848 61.3018 30.2467 60.949 29.7312 60.2435L20.7965 47.7674C20.287 47.0778 20.0322 46.2334 20.0322 45.2343C20.0322 44.2346 20.281 43.3819 20.7785 42.6764C21.336 41.9175 21.9762 41.5381 22.6992 41.5381C23.4222 41.5381 24.0327 41.8829 24.5307 42.5725Z",
    fill: "#FCBE1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskSuccess);
export default __webpack_public_path__ + "static/media/taskSuccess.fd51eae08d2c99492b251662a3363e47.svg";
export { ForwardRef as ReactComponent };